import { Subject } from 'rxjs';
import {
  WifiSubscriptionEvent,
  WifiSubscriptionEventType,
} from '../../api/hooks/wifi.hooks';
import { ApplicationConfig } from '../../config/config';
import { sleep } from '../../util/async';

const simulateWiFiEvents = async (
  wifiSubscription$: Subject<WifiSubscriptionEvent>,
  ssid: string
) => {
  wifiSubscription$.next({
    type: WifiSubscriptionEventType.CONNECTING,
    wifiInfo: {
      ssid,
    },
  });

  await sleep(1000);

  wifiSubscription$.next({
    type: WifiSubscriptionEventType.CONNECTED,
    wifiInfo: {
      ssid,
      // This baffles me, and perhaps this is an issue with iOS or
      // the Wi-Fi plugin code we use, but the iOS plugin calls the
      // gateway the IP address and the IP address the gateway.
      // So we swap the simulation values here rather than confuse
      // ourselves when entering the data in the simulation config.
      gateway: ApplicationConfig.simulate.wifi.ipAddress,
      ipAddress: ApplicationConfig.simulate.wifi.gateway,
    },
  });
};

export { simulateWiFiEvents };
